import { Store, applyMiddleware, createStore } from 'redux';
import rootReducer, { AppState, InitialState } from './index';

import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';

export default function configureStore(initialState: InitialState): Store<AppState> {
	return createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(thunkMiddleware)));
}
